import React from 'react';
import { Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { SalesRepPaymentRow } from '../../utils/salesRepresentativePayment';
import { hasInvoicesInPeriod } from '../../utils/salesRepresentativePayment';

const { Text } = Typography;

type Props = {
  row: SalesRepPaymentRow;
};

const SalesRepPaymentPercentage: React.FC<Props> = ({ row }) => {
  const { t } = useTranslation();

  if (!hasInvoicesInPeriod(row)) {
    return (
      <Tooltip title={t('dashboard.noInvoicesInPeriod')}>
        <Text type="secondary">—</Text>
      </Tooltip>
    );
  }

  return <Text>{Number(row.payment_percentage ?? 0).toFixed(2)}%</Text>;
};

export default SalesRepPaymentPercentage;
